import { CircleMemberContext } from '@/circle/contexts/CircleMemberContext'
import { MentionEntities } from '@rolebase/editor/react'
import { useCallback, useContext } from 'react'

// A click on a mention opens what it names (#92): the role's panel for a role
// or a circle, the person for a person — the same way a role or member link
// does elsewhere in the app.
export default function useMentionClick() {
  const circleMemberContext = useContext(CircleMemberContext)

  return useCallback(
    (entity: MentionEntities, id: string) => {
      if (entity === MentionEntities.Role) {
        circleMemberContext?.goTo(id)
      } else {
        circleMemberContext?.goTo(undefined, id)
      }
    },
    [circleMemberContext]
  )
}
